import { CIRB_QUEUED_ACTIONS } from './cirb/QueuedProcessAction';
import { CIRB_ACTIONS } from './cirb';
import { SUMMARY_ACTIONS, INSTITUTION_ACTIONS, EMAIL_ACTIONS } from './common';
import { IDP_ACTIONS } from './idp';
import { IRB_ACTIONS } from './irb';
import { PACKET_ACTIONS } from './packet';
import { RDIMS_ACTIONS } from './rdims';
import { SITEREGISTRATION_ACTIONS } from './siteregistration';

const types = {
  ...CIRB_QUEUED_ACTIONS,
  ...CIRB_ACTIONS,
  ...SUMMARY_ACTIONS,
  ...INSTITUTION_ACTIONS,
  ...EMAIL_ACTIONS,
  ...IDP_ACTIONS,
  ...IRB_ACTIONS,
  ...PACKET_ACTIONS,
  ...RDIMS_ACTIONS,
  ...SITEREGISTRATION_ACTIONS
};

export default types;
